import { Navigate, useLocation } from 'react-router-dom';

import BootLoader from '../../../common/components/boot-loader/boot-loader';
import { ROUTES } from '../../../core/constants/routes';
import { useAuth } from './auth';

// The permission check must run after `initializing` resolves; otherwise users
// get bounced to /unauthorized during the bootstrap (vite/05 "Session bootstrap").
export function ProtectedRoute({ domain, any, children }) {
    const { initializing, isAuthenticated, can, canAny } = useAuth();
    const location = useLocation();
    if (initializing) return <BootLoader />;
    if (!isAuthenticated) return <Navigate to={ROUTES.LOGIN} replace state={{ from: location.pathname }} />;
    const isAllowed = domain ? can(domain) : canAny(...(any || []));
    if (!isAllowed) return <Navigate to={ROUTES.UNAUTHORIZED} replace />;
    return children;
}

export function AuthRoute({ children }) {
    const { initializing, isAuthenticated } = useAuth();
    if (initializing) return <BootLoader />;
    if (!isAuthenticated) return <Navigate to={ROUTES.LOGIN} replace />;
    return children;
}
